import React, { useState } from "react";
import MenuIcon from "@atlaskit/icon/core/menu";
import { Popover } from "antd";
import DeleteFlowMenuItem from "./DeleteFlowMenuItem";
import DuplicateFlowMenuItem from "./DuplicateFlowMenuItem";
import SetFlowGroupMenuItem from "./SetFlowGroupMenuItem";

import Button from "@atlaskit/button/new";
import { token } from "@atlaskit/tokens";

const FlowActionMenu = ({ flow }) => {
  const [showMenu, setShowMenu] = useState(false);

  const handleClickChange = (visible) => {
    setShowMenu(visible);
  };

  const onClickCallback = () => {
    setShowMenu(false);
  };

  const renderContent = () => {
    return (
      <>
        <SetFlowGroupMenuItem flow={flow} onClickCallback={onClickCallback} />
        <br />
        <strong style={{ color: token("color.text", "#172b4d") }}>Actions</strong>
        <br />
        <DeleteFlowMenuItem flow={flow} onClickCallback={onClickCallback} />
        <br />
        <DuplicateFlowMenuItem flow={flow} onClickCallback={onClickCallback} />
      </>
    );
  };

  return (
    <>
      <Popover content={renderContent()} title="" trigger="click" open={showMenu} onOpenChange={handleClickChange}>
        <Button
          iconBefore={MenuIcon}
          appearance="subtle"
          onClick={() => {
            setShowMenu(!showMenu);
          }}
        />
      </Popover>
    </>
  );
};
export default FlowActionMenu;
